import { useGoodsReceiptActions } from "../../../hooks"
import type { GoodsReceiptActionState } from "../../../types"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface UseStoredGoodsReceiptActionsProps {
  goodsReceipt?: GoodsReceipt | null
  onRefetch?: () => void
}

interface UseStoredGoodsReceiptActionsReturn {
  actionState: GoodsReceiptActionState
  handleDialogClose: () => void
  handleEditGoodsReceipt: (goodsReceipt: GoodsReceipt) => void
  handleUpload: () => void
}

export const useStoredGoodsReceiptActions = ({
  goodsReceipt,
  onRefetch,
}: UseStoredGoodsReceiptActionsProps): UseStoredGoodsReceiptActionsReturn => {
  const { actionState, handleDialogClose, handleEditGoodsReceipt, handleUploadFiles } = useGoodsReceiptActions({
    goodsReceipt,
    onRefetch,
  })

  return {
    actionState,
    handleDialogClose,
    handleEditGoodsReceipt,
    handleUpload: handleUploadFiles,
  }
}
